import { createSlice } from "@reduxjs/toolkit";
// eslint-disable-next-line no-duplicate-imports
import type { PayloadAction } from "@reduxjs/toolkit";

interface HandoverState {
  canRequestNewPin: boolean;
  otpSendingInProgress?: boolean;
  affiliateDetails?: any;
}

export const initialState: HandoverState = {
  canRequestNewPin: false
};

const handoverSlice = createSlice({
  name: "handover",
  initialState,
  reducers: {
    requestNewPin(state) {
      return state;
    },
    toggleRequestingNewPin(state, action: PayloadAction<{ canRequestNewPin: boolean; otpSendingInProgress: boolean }>) {
      state.canRequestNewPin = action.payload.canRequestNewPin;
      state.otpSendingInProgress = action.payload.otpSendingInProgress;
    },
    passAffiliateDetails(state, action) {
      state.affiliateDetails = action.payload;
    },
    handoverCompletedInOtherTab(state) {
      return state;
    },
    submitHandoverUpdateEmailForm(state, action: PayloadAction<string>) {
      return state;
    },
    destroy() {
      return initialState;
    }
  }
});

export default handoverSlice.reducer;
export const {
  requestNewPin,
  toggleRequestingNewPin,
  passAffiliateDetails,
  handoverCompletedInOtherTab,
  submitHandoverUpdateEmailForm,
  destroy
} = handoverSlice.actions;
export const handoverActions = handoverSlice.actions;
